import './ImageAttribution.css';

function safeUrl(value) {
  try {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
  } catch { return null; }
}

function SourceLink({ url }) {
  const host = new URL(url).hostname;
  const label = `Open image source: ${host}`;
  return <a className="og-image-source-link" href={url} target="_blank" rel="noopener noreferrer" aria-label={label} title={label}>
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-2 2M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l2-2" />
    </svg>
  </a>;
}

export default function ImageAttribution({ text, url, license }) {
  const seen = new Set();
  function render(value, prefix) {
    return String(value || '').split(/(https?:\/\/[^\s<>"]+)/gi).map((part, index) => {
      if (!/^https?:\/\//i.test(part)) return part;
      const trailing = part.match(/[.,;:!?\]\)]+$/)?.[0] || '';
      const href = safeUrl(trailing ? part.slice(0, -trailing.length) : part);
      if (!href) return part;
      seen.add(href);
      return <span key={prefix + index}><SourceLink url={href} />{trailing}</span>;
    });
  }
  const credit = render(text, 'credit');
  const licenseText = render(license, 'license');
  const canonical = safeUrl(url);
  return <span className="og-image-attribution">
    {credit}
    {canonical && !seen.has(canonical) && <SourceLink url={canonical} />}
    {license && <span className="og-image-license"> · {licenseText}</span>}
  </span>;
}
